export const FetchActionKeys = {
  FETCH: 'Fetch',
  FETCH_SUCCESS: 'Fetch Success',
  FETCH_FAILURE: 'Fetch Failure',
  FETCH_RESET: 'Fetch Reset',
  DOWNLOAD: 'Download',
  DOWNLOAD_FAILURE: 'Download Failure'
} as const;

export const SET_BUSINESS_UNIT_ID = 'Set business unit id';

export const SET_COLUMN_CONFIG = 'Set column config';
